import {
    ICreateAndPopulateCartRequest,
    ICreateAndPopulateCartResponse
} from 'api/Idi/Idi.api.types';
import axios from 'axios';
import { Config } from 'config';

export interface IPaymentSessionResponse {
    sessionId: string;
    amountDue: number;
    cartId: number;
}

export const GetSessionId = (
    request: ICreateAndPopulateCartRequest,
    onSuccess: (response: ICreateAndPopulateCartResponse) => void,
    onFailure: (reason: object) => void
) => {
    axios.post<ICreateAndPopulateCartResponse>(Config.url.PAYMENT_URL, request).then(
        (response) => onSuccess(response?.data),
        (reason) => onFailure(reason)
    );
};
